module.exports = __webpack_public_path__ + "img/zhange.d80c7f55.png";